export default __webpack_public_path__ + "static/media/ps2.e3ae920e.png";